import {useDiscipline} from "@/hooks/useDiscipline";
import clsxm from "@/lib/clsxm";
import {disciplineTabAtom} from "@/store/jotaiAtoms";
import type {TDisciplineTab} from "@/store/types";
import {useAtom} from "jotai";
import {type FC, memo, type PropsWithChildren, type ReactNode} from "react";

type Tab = {atomValue?: TDisciplineTab; title: string; Icon?: ReactNode; isActive?: boolean};

const DisciplineTabs: FC<PropsWithChildren & {tabs: Tab[]}> = ({children, tabs}) => {
  const [selectedTab, setSelectedTab] = useAtom(disciplineTabAtom);
  const {setDisciplineByTab} = useDiscipline();

  return (
    <div className="transition-all">
      <div className="text-neutral-black-dark relative flex justify-between overflow-x-auto text-sm font-semibold">
        <div className="flex gap-3 px-5">
          {tabs.map((tab, index) => (
            <button
              className={clsxm(
                "border-neutral-grey-light-dark bg-neutral-white-dark z-1 flex cursor-pointer items-center gap-2 rounded-t-lg border border-b-white px-3 py-2 transition-all",
                (selectedTab === tab.atomValue || !tab.atomValue) && "bg-white",
                !tab.atomValue && "cursor-default",
                index === 1 && "ml-3",
              )}
              key={tab.atomValue + index.toString()}
              onClick={() => {
                if (tab.atomValue) {
                  setSelectedTab(tab.atomValue);
                  setDisciplineByTab(tab.atomValue);
                }
              }}>
              {tab.isActive && (
                <div className="border-neutral-grey-light-dark bg-success-medium-green size-3 rounded-full" />
              )}
              {tab.Icon && tab.Icon}
              {tab.title}
            </button>
          ))}
        </div>
        <div className="bg-neutral-grey-light-dark absolute bottom-[1px] h-[0.5px] w-full" />
      </div>
      <div>{children}</div>
    </div>
  );
};

export default memo(DisciplineTabs);
